import {
  FETCH_ACCOUNT_DETAILS_FULFILLED,
  FETCH_ACCOUNT_DETAILS_PENDING,
  FETCH_ACCOUNT_DETAILS_REJECTED,
} from '../actions';

const initialState = {};

const account = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_DETAILS_PENDING:
      return {
        ...state,
        busy: true,
      };
    case FETCH_ACCOUNT_DETAILS_FULFILLED:
      return {
        ...state,
        busy: false,
        error: undefined,
        ...action.payload,
      };
    case FETCH_ACCOUNT_DETAILS_REJECTED:
      return {
        ...state,
        busy: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default account;
